import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import CompanyService from '../Services/CompanyService';
import {extractErrorMessage} from '../Services/RequestService';
import {removeFromCollection, replaceInCollection} from './utils';

export const useCompanies = () => {
    const [companies, setCompanies] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            let resp = await CompanyService.allCompanies(token);
            setCompanies(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addCompany = async (company) => {
        try {
            let resp = await CompanyService.addCompany(company, token);
            setCompanies([...companies, {...company, id: resp.data.id}]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateCompany = async (company) => {
        try {
            await CompanyService.updateCompany(company, token);
            setCompanies(replaceInCollection(company, companies));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteCompany = async (company) => {
        try {
            await CompanyService.deleteCompany(company.id, token);
            setCompanies(removeFromCollection(company, companies));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [companies, addCompany, updateCompany, deleteCompany];
}


// WEBPACK FOOTER //
// ./src/Hooks/useCompanies.js